export enum StatsDataKeyEnum {
  conversation = 'countConversations',
  conversationsHour = 'countConversationsHour'
}
